require("!!/clarity-seed/node_modules/script-loader/addScript.js")(require("!!/clarity-seed/node_modules/raw-loader/index.js!/clarity-seed/node_modules/@webcomponents/custom-elements/custom-elements.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/@webcomponents/custom-elements/custom-elements.min.js
// module id = 489
// module chunks = 1